import { render, staticRenderFns } from "./DisapproveModal.vue?vue&type=template&id=2906c6f5&"
import script from "./DisapproveModal.vue?vue&type=script&lang=js&"
export * from "./DisapproveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports